module.exports = {
      id: "Ee-logoWhite-usage",
      viewBox: "0 0 38 37",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Ee-logoWhite-usage",
      toString: function () {
        return this.url;
      }
    }